(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/betslip-match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/betslip-match.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BetslipMatch = Backbone.Model.extend({
    setData: function(
      marks,
      eventDescription,
      h2hDescription,
      eventNumber,
      weights
    ) {
      this.set(
        {
          marks: marks,
          eventDescription: eventDescription,
          h2hDescription: h2hDescription,
          eventNumber: eventNumber,
          weights: weights
        },
        { silent: true }
      );
      this.trigger('change', this); 
    }
  });
})(Backbone, _, svs);

 })(window);